import { inject, injectable } from "inversify";
import HttpService from "./http.service";
import IdentityService from "./identity.service";
import ToastService from "./toast.service";
import { ArtworkService, AdminService as adminService } from "./openapi/generated";

@injectable()
export default class AdminService {
    @inject(HttpService)
    public httpService: HttpService;

    @inject(IdentityService)
    public identity: IdentityService;

    @inject(ToastService)
    public toastService: ToastService;

    public async listUsers(): Promise<void> {
        const res = await adminService.adminControllerFindAll();
        (window as any).store.dispatch({ type: "SET_USERS", value: res.users });
    }

    public async listExpenses(): Promise<void> {
        const res = await adminService.adminControllerGetExpenses();
        (window as any).store.dispatch({ type: "SET_EXPENSES", value: res.expenses });
    }

    public async listArtworks(): Promise<void> {
        const res = await ArtworkService.artworkControllerGetArtworkPage(1, -1);
        (window as any).store.dispatch({ type: "SET_ARTWORKS", value: res.filter((a) => a.deleted !== true) });
    }

    public async verifyUser(id: number): Promise<void> {
        await adminService.adminControllerVerify(id.toString());
        (window as any).store.dispatch({ type: "SET_USER_VERIFIED", value: id });
        this.toastService.showToast("User verified", "", "success");
    }

    public async rejectUser(id: number): Promise<void> {
        await adminService.adminControllerReject(id.toString());
        (window as any).store.dispatch({ type: "SET_USER_REJECTED", value: id });
        this.toastService.showToast("User rejected", "", "success");
    }

    public async blockUser(id: number): Promise<void> {
        await adminService.adminControllerBlock(id.toString());
        (window as any).store.dispatch({ type: "SET_USER_BLOCKED", value: id });
        this.toastService.showToast("User blocked", "", "success");
    }

    public async unblockUser(id: number): Promise<void> {
        await adminService.adminControllerUnblock(id.toString());
        (window as any).store.dispatch({ type: "SET_USER_UNBLOCKED", value: id });
        this.toastService.showToast("User unblocked", "", "success");
    }

    public async deleteUser(id: number): Promise<void> {
        await adminService.adminControllerDeleteUser(id.toString());
        (window as any).store.dispatch({ type: "DELETE_USER", value: id });
        this.toastService.showToast("User deleted", "", "success");
    }

    public async deleteArtwork(id: number): Promise<void> {
        await adminService.adminControllerDeleteArtwork(id.toString());
        (window as any).store.dispatch({ type: "DELETE_ARTWORK", value: id });
        this.toastService.showToast("Artwork deleted", "", "success");
    }
}



// WEBPACK FOOTER //
// ./src/services/admin.service.ts